import { Controller } from "@hotwired/stimulus"

// Phase 2.7 Tier 2 — UI glue for meeting action items. The backend
// model layer auto-creates the linked Punchlist on save (see
// `MeetingItem#ensure_action_punchlist_present`); this controller
// just opens the linked Punchlist's slide-over when the user clicks
// the inline pill so they don't have to navigate to the punchlists
// page.
//
// Wire by adding `data-controller="meeting-action"` to the meeting
// item card root and `data-action="click->meeting-action#openSlideOver"
// data-meeting-action-punchlist-id="123"` to the trigger link.
export default class extends Controller {
  openSlideOver(event) {
    const punchlistId = event.params?.punchlistId ||
      event.currentTarget.dataset.meetingActionPunchlistId ||
      event.currentTarget.dataset.punchlistId
    if (!punchlistId) return

    // Reuse the existing Action Items slide-over: dispatching a custom
    // event that `action_items_controller` listens to keeps this code
    // independent of the slide-over's internals.
    const detail = { punchlistId: String(punchlistId) }
    document.dispatchEvent(new CustomEvent("action-items:open", { detail }))
  }
}
